// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-quinn-residences -> quinn-residences-websites -> newell-village
// Generated: 2026-10-29T18:33:29.970Z
// Counts: 0 design, 26 content, 51 slot group, 0 collection binding, 6 section, 0 style

export const designOverrides = {};

export const contentOverrides = {
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose the layout that fits your day </p>",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>A simple breakdown of the fees, services, and optional costs associated with living at <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "easy-fee-guide-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Know your costs before you move in.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.height": {
    "overrideType": "VALUE",
    "customValue": "1000",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.lead": {
    "overrideType": "VALUE",
    "customValue": "<p>Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "nextstep.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See townhome living in person</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourquestions.when_a": {
    "overrideType": "VALUE",
    "customValue": "<p>The scheduler shows the times you can book.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.self_guided_tour_link": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_self_guided_tour_url"
  },
  "tourscheduler.widget.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "tourscheduler.widget.use_leads_tour_times": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Inside, you get granite countertops, stainless steel appliances, luxury flooring, in-unit laundry, and smart-home controls. Outside, lawn maintenance and pet waste stations take care of the chores. See every <a href=\"/amenities\">home and community feature</a>.</p>",
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Smart townhomes, lawn care included</p>",
    "mappedField": null
  },
  "amenityhighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Outside your door, Newell Village keeps things easy: a playground and open green space for the kids, pet waste stations along the way, and lawn care handled for you. See more of the grounds in the <a href=\"/gallery\">gallery</a>.</p>",
    "mappedField": null
  },
  "feetable.concierge_note": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Includes a bi-annual filter change, exterior pest control, 24-hour maintenance response on emergencies, and positive credit reporting.</p>",
    "mappedField": null
  },
  "floorplanshero.offer_label": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Reduced deposit and waived fees</p>",
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Brand-new three-bedroom townhomes in Newell South</p>",
    "mappedField": null
  },
  "interactivemapcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Find your open townhome, street by street.</p>",
    "mappedField": null
  },
  "lifestylehighlights.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Life at Newell Village is less about a clubhouse and more about time back in your week: lawn care is handled for you, pet waste stations sit along your daily walk, and a playground is on the way. See the full list of <a href=\"/amenities\">community and home features</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Grab groceries and dinner along University City Boulevard, catch the LYNX Blue Line toward NoDa and Uptown, or spend a Saturday on the trails at Reedy Creek Park, all close to UNC Charlotte and University Research Park. Get to know the <a href=\"/neighborhood\">neighborhood</a>.</p>",
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Newell South, minutes from University City</p>",
    "mappedField": null
  },
  "petpolicy.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Cats and dogs settle right in at Newell Village, with pet waste stations around the community, grassy lawns for quick walks, and Reedy Creek Park and Nature Center close by for longer outings. Get the full details in our <a href=\"/pet-policy\">pet policy</a>.</p>",
    "mappedField": null
  },
  "petpolicy.title": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Room for your pets to roam</p>",
    "mappedField": null
  },
  "touroptions.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Walk through the Kent and Katana townhomes in <a href=\"/virtual-tours\">3D</a> from anywhere, then see one in person on a <a href=\"/schedule-a-tour\">self-guided tour</a> or with our leasing team.</p>",
    "mappedField": null
  },
  "virtualtourembed.lead": {
    "overrideType": "GENERATOR",
    "customValue": null,
    "generatedValue": "<p>Step inside both Newell Village townhomes in 3D: the 1,467 sq ft Kent and the 1,584 sq ft Katana. Each has three bedrooms and 2.5 baths, so pick a tour and look around, then compare them on our <a href=\"/floor-plans\">floor plans</a> page.</p>",
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactdetails.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "mappedField": "",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanshero.link_fees": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/easy-fee-guide"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "floorplanshero.link_pets": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/pet-policy"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "whyquinn.pillar_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Easy access to great schools, shopping, dining, and everyday essentials."
      }
    }
  },
  "whyquinn.pillar_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Spacious layouts that blend functionality, comfort, and modern style."
      }
    }
  },
  "whyquinn.pillar_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Community-Focused Amenities"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Shared spaces designed to bring neighbors together and create lasting memories."
      }
    }
  },
  "whyquinn.pillar_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Dedicated support and personalized service for a hassle-free rental experience."
      }
    }
  },
  "whyquinn.pillar_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "Energy-efficient homes built to reduce environmental impact and help lower your utility costs."
      }
    }
  },
  "amenitieslist.amenity_photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Maintenance"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1c3c-742a-b8d6-06809c137c29.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Private backyard with a green lawn and black fence behind a gray townhome"
      }
    }
  },
  "amenitieslist.amenity_photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Smart Home Technology"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a15ec5-9489-753e-8d59-15e643cca111.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Living room with a beige couch, coffee table, and wall-mounted flat-screen TV"
      }
    }
  },
  "amenitieslist.amenity_photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Future Playground"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-1eb2-70ae-b90c-fd5a8f27fb19.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Community playground with a green slide and monkey bars"
      }
    }
  },
  "amenitieslist.amenity_photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Pet Waste Station"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa5-0530-76de-b0a2-31d1dead20be.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of townhomes with garages and manicured lawns."
      }
    }
  },
  "amenitieslist.amenity_photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Stainless Steel Appliances"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/01a183b0-0e41-7171-aea8-089b52784287.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with stainless steel refrigerator, oven, and microwave beside light gray cabinets"
      }
    }
  },
  "amenitieslist.amenity_photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amenity": {
        "type": "GENERATOR",
        "generatedValue": "Granite Countertops"
      },
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa4-888e-76ab-b1da-13230dded129.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with granite island and stainless steel appliances."
      }
    }
  },
  "amenitieslist.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-d0e9-7518-9aa8-5eff83c98e03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children's playground with slides, swings, and climbing structures."
      }
    }
  },
  "amenitygroups.community_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa8-08e1-76fd-8ab7-2bc21376ad2f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Newell Village townhome rows surrounded by green space"
      }
    }
  },
  "amenitygroups.home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-9032-705d-820f-7285eaeb112b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living room and granite kitchen in a Newell Village townhome"
      }
    }
  },
  "amenityhighlights.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-d0e9-7518-9aa8-5eff83c98e03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children's playground with slides, swings, and climbing structures."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Playground"
      }
    }
  },
  "amenityhighlights.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa4-95e2-75ea-93c7-0e9a696ff586.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes with a playground and green space."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Green Space"
      }
    }
  },
  "amenityhighlights.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-4c83-771c-bde3-3a4dc01ba2e9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of Newell Village townhomes with manicured front lawns"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Lawn Care"
      }
    }
  },
  "amenityhighlights.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with bar stools."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Granite Kitchens"
      }
    }
  },
  "amenityhighlights.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-946d-73a1-af13-1bf5fe16db1b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Washing machine and dryer in laundry closet"
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "In-Unit Laundry"
      }
    }
  },
  "amenityhighlights.card_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa4-bc05-74a8-aa4a-620155edb206.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Interior of a vacant garage with an open overhead door and an automatic opener."
      },
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Attached Garage"
      }
    }
  },
  "floorplanshero.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-e1de-72ec-9b43-76334acc54cc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Newell Village townhomes with attached garages under a bright blue sky"
      }
    }
  },
  "floorplanshero.photo_10": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa8-08e1-76fd-8ab7-2bc21376ad2f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of a newly constructed multifamily property with rows of townhomes and surrounding green space."
      }
    }
  },
  "floorplanshero.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with bar stools."
      }
    }
  },
  "floorplanshero.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-fbf0-744c-9b32-f0e95de17858.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Open living room flowing into a kitchen with a large island"
      }
    }
  },
  "floorplanshero.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-4c83-771c-bde3-3a4dc01ba2e9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of townhomes with manicured lawns under blue skies"
      }
    }
  },
  "floorplanshero.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-fd28-7179-a214-0eaf22e8a851.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Primary bedroom with a king bed and nightstands"
      }
    }
  },
  "floorplanshero.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-d0e9-7518-9aa8-5eff83c98e03.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Children's playground with slides, swings, and climbing structures."
      }
    }
  },
  "floorplanshero.photo_7": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-fd9c-7257-8bdb-1da4aa1338c0.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "a kitchen with granite counter tops and stainless steel appliances"
      }
    }
  },
  "floorplanshero.photo_8": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-2a07-731e-a414-f2ce75dd0779.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Townhomes with white siding, gray roofs, and attached garages"
      }
    }
  },
  "floorplanshero.photo_9": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-f9a4-75f9-aa3f-cd50b37f4e57.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Bright living area with a sofa, desk, and large windows"
      }
    }
  },
  "lifestylehighlights.highlight_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Weekends Back"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lawn maintenance is included, so Saturday mornings go to coffee and the porch instead of the mower."
      }
    }
  },
  "lifestylehighlights.highlight_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Play Close By"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "A future community playground will give kids and neighbors an easy spot to meet up just outside your door."
      }
    }
  },
  "lifestylehighlights.highlight_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Room to Focus"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "With three bedrooms and smart-home climate controls, the spare room makes a quiet, comfortable home office."
      }
    }
  },
  "neighborhoodcallout.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec32-fd09-7475-a030-42ad922f92aa.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Wooded grounds at Reedy Creek Nature Center in Charlotte"
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Reedy Creek Nature Center"
      }
    }
  },
  "petpolicy.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-b803-702f-82b0-ca749c5675d5.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Backyard view of a townhouse with a green lawn, white privacy fence, black metal fence, and a patio with an AC unit."
      },
      "caption": {
        "type": "GENERATOR",
        "generatedValue": "Private backyard lawn"
      }
    }
  },
  "propertyoverview.photo_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-2a07-731e-a414-f2ce75dd0779.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Newell Village townhomes with attached garages and landscaped yards"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Townhome Exteriors"
      }
    }
  },
  "propertyoverview.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-8f89-7658-801a-48b46c674c96.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern kitchen with gray cabinets, granite countertops, stainless steel appliances, and an island with bar stools."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen"
      }
    }
  },
  "propertyoverview.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15ec5-9032-705d-820f-7285eaeb112b.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious living room and kitchen area with modern finishes and a large sectional sofa."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Living Area"
      }
    }
  },
  "propertyoverview.photo_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec31-4c83-771c-bde3-3a4dc01ba2e9.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Row of townhomes with blue and white siding and green lawns"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Community"
      }
    }
  },
  "propertyoverview.photo_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa4-8a34-734a-92a4-7e67c36f439f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Spacious bedroom with a king-sized bed, white bedding, and decorative pillows."
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Primary Bedroom"
      }
    }
  },
  "propertyoverview.photo_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167641/01a15aa8-08e1-76fd-8ab7-2bc21376ad2f.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Aerial view of Newell Village townhomes surrounded by green space"
      },
      "title": {
        "type": "GENERATOR",
        "generatedValue": "Aerial View"
      }
    }
  },
  "reviewthemes.chip_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Easy move-in"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "made the entire process easy and seamless"
      }
    }
  },
  "reviewthemes.chip_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Helpful maintenance"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "went above and beyond to fix my issue"
      }
    }
  },
  "reviewthemes.chip_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Great communication"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "kept me informed on the process"
      }
    }
  },
  "reviewthemes.chip_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Friendly staff"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "always walking around with a smile"
      }
    }
  },
  "reviewthemes.chip_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Community feel"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "an outstanding community"
      }
    }
  },
  "reviewthemes.chip_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "GENERATOR",
        "generatedValue": "Great service"
      },
      "signal": {
        "type": "GENERATOR",
        "generatedValue": "provided amazing customer service"
      }
    }
  },
  "tourhero.photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167641/019fec30-e1de-72ec-9b43-76334acc54cc.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern townhomes with attached garages under a bright blue sky at Newell Village in Charlotte"
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ]
};

export const styleOverrides = {};
